import { render } from "./MulagSaobracaj.vue?vue&type=template&id=2e1fc98a&scoped=true"
import script from "./MulagSaobracaj.vue?vue&type=script&lang=js"
export * from "./MulagSaobracaj.vue?vue&type=script&lang=js"

import "./MulagSaobracaj.vue?vue&type=style&index=0&id=2e1fc98a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1fc98a"]])

export default __exports__